module.exports = __webpack_public_path__ + "static/media/ruleta.b9ec6525.png";